import { useState, useEffect } from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useAuth, API } from '../App';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export default function OnboardingTour() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    // Show tour if user hasn't completed onboarding
    if (user && !user.onboarding_completed) {
      setTimeout(() => setRun(true), 1000); // Small delay for page to load
    }
  }, [user]);

  const steps = [
    {
      target: 'body',
      content: (
        <div>
          <h2 className="text-xl font-bold mb-2">🎉 {t('onboarding.welcome')}</h2>
          <p>{t('onboarding.welcomeMessage')}</p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '.max-w-7xl nav',
      content: (
        <div>
          <h3 className="font-bold mb-1">{t('onboarding.dashboard')}</h3>
          <p>{t('onboarding.dashboardDesc')}</p>
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div>
          <h3 className="font-bold mb-1">{t('onboarding.browse')}</h3>
          <p>{t('onboarding.browseDesc')}</p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div>
          <h3 className="font-bold mb-1">{t('onboarding.messages')}</h3>
          <p>{t('onboarding.messagesDesc')}</p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div>
          <h3 className="font-bold mb-1">{t('onboarding.profile')}</h3>
          <p>{t('onboarding.profileDesc')}</p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div>
          <h2 className="text-xl font-bold mb-2">✅ {t('onboarding.ready')}</h2>
          <p>{t('onboarding.readyMessage')}</p>
          <p className="mt-2 text-sm text-gray-600">{t('onboarding.nextStep')}</p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  const handleJoyrideCallback = async (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Mark onboarding as completed
      try {
        await axios.post(`${API}/onboarding/complete`, {}, { withCredentials: true });
        setRun(false);
      } catch (error) {
        console.error('Error completing onboarding:', error);
      }
    }
  };

  if (!user || user.onboarding_completed) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      continuous
      showProgress
      showSkipButton
      styles={{
        options: {
          primaryColor: '#14b8a6',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: 10,
        },
        buttonNext: {
          backgroundColor: '#14b8a6',
          borderRadius: 5,
          padding: '8px 16px',
        },
        buttonBack: {
          color: '#666',
        },
      }}
      locale={{
        back: t('onboarding.back'),
        close: t('onboarding.close'),
        last: t('onboarding.finish'),
        next: t('onboarding.next'),
        skip: t('onboarding.skip'),
      }}
    />
  );
}
